import {
  Box,
  Grid,
  MenuItem,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import AutoComleteFilter from 'components/AutoCompleteFilter';
import { OrangeButton } from 'components/Button';
import InputField from 'components/InputField';
import {
  CASABLANCA,
  FILTERS,
  FILTERS_BY_UNIVERSE,
  FILTER_WITH_FROM_SOURCE,
  UNIVERSES,
} from 'components/MapFilter/constants';
import messages from 'components/MapFilter/messages';
import SelectInputField from 'components/SelectInputField';
import { LocationResponse } from 'containers/ServicesPage/types';
import { FormikProps, withFormik } from 'formik';
import { translate } from 'helpers/intl';
import { get } from 'lodash';
import React, { useEffect } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { connect } from 'react-redux';
import { useLocation } from 'react-router';
import { useLastLocation } from 'react-router-last-location';
import { createStructuredSelector } from 'reselect';
import pages from 'routes/pages';
import { getCities } from 'store/geolocAgent/actions';
import {
  getCitiesSelector,
  getIsLoadingCitiesSelector,
} from 'store/geolocAgent/selectors';
import { getLocations } from 'store/global/actions';
import {
  getLocationFilterSelector,
  getLocationsSelector,
} from 'store/global/selectors';
import { FormValues, handleSubmit } from './utils';

const MapFilter = (
  props: {
    getCities: Function;
    getLocations: Function;
    filterWith: string;
    cities: any;
    locations: LocationResponse[];
    isLoadingCities: boolean;
  } & FormikProps<FormValues>,
) => {
  const {
    values,
    handleSubmit,
    handleChange,
    handleBlur,
    setFieldValue,
  } = props;
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));
  const { state } = useLocation();
  const location = useLastLocation();
  const univers = UNIVERSES();

  useEffect(() => {
    /* istanbul ignore next */
    if (location?.pathname === pages.AMC_DASHBOARD) {
      setFieldValue('universe', univers[1].value);
      const source = get(state, 'source', '');
      const filterWidth = source && FILTER_WITH_FROM_SOURCE[source];
      if (filterWidth) {
        setFieldValue('filterWith', filterWidth);
      }
    }
  }, [location?.pathname]);

  const filterTypes = values.universe
    ? FILTERS_BY_UNIVERSE[values.universe]
    : Object.keys(FILTERS);

  return (
    <form onSubmit={handleSubmit}>
      <Box py={4}>
        <Grid container spacing={2}>
          <Grid item xs={matches ? 12 : 8}>
            <InputField
              placeholder={translate(get(messages, 'research'), props)}
              name="research"
              value={values.research}
              handleChange={handleChange}
              handleBlur={handleBlur}
              startAdornment={
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              }
            />
          </Grid>
          {!matches && (
            <Grid item xs={matches ? 12 : 4}>
              <OrangeButton type="submit" variant="contained">
                {translate(get(messages, 'research'), props)}
              </OrangeButton>
            </Grid>
          )}
          <Grid item xs={matches ? 12 : 4}>
            <SelectInputField
              label={translate(get(messages, 'universe'), props)}
              name="universe"
              onChange={handleChange}
              value={values.universe}
              data={univers}
              handleBlur={handleBlur}
              Children={univers
                .filter((ele) => {
                  return ele.isVisible;
                })
                .map((item: any) => (
                  <MenuItem value={item.value} key={item.label}>
                    {translate(get(messages, item.label), props)}
                  </MenuItem>
                ))}
            />
          </Grid>
          <Grid item xs={matches ? 12 : 4}>
            <SelectInputField
              label={translate(get(messages, 'filterWith'), props)}
              name="filterWith"
              onChange={handleChange}
              value={values.filterWith}
              data={univers}
              handleBlur={handleBlur}
              Children={filterTypes
                // TO DO remove filter when clinics are supported
                .filter(
                  (item: string) =>
                    item !== 'clinics' && item !== 'reseau_national',
                )
                .map((item: any) => (
                  //@ts-ignore
                  <MenuItem value={FILTERS[item]} key={item}>
                    {translate(get(messages, item), props)}
                  </MenuItem>
                ))}
            />
          </Grid>
          <Grid item xs={matches ? 12 : 4}>
            <AutoComleteFilter
              label={translate(get(messages, 'city'), props)}
              placeholder={translate(get(messages, 'city'), props)}
              name="city"
              value={values.city}
              options={Array.from(props.cities)}
              isLoading={props.isLoadingCities}
              setFieldValue={setFieldValue}
              getItems={props.getCities}
            />
          </Grid>
          {matches && (
            <Grid item xs={matches ? 12 : 4}>
              <OrangeButton type="submit" variant="contained">
                {translate(get(messages, 'research'), props)}
              </OrangeButton>
            </Grid>
          )}
        </Grid>
      </Box>
    </form>
  );
};

export interface FormProps {
  intl: IntlShape;
  isLoadingCities: boolean;
  cities: any;
  locations: LocationResponse[];
  getCities: Function;
  getLocations: Function;
  getDoctors: (payload: any) => void;
  setCenter: Function;
  setFilter: (filter: any) => void;
  filterWith: string;
}

const EnhancedMapFilter = withFormik<FormProps, FormValues>({
  mapPropsToValues: (props) => {
    return {
      research: '',
      universe: '',
      filterWith: props.filterWith,
      city: CASABLANCA,
    };
  },
  handleSubmit,
})(MapFilter);

const mapStateToProps = createStructuredSelector<
  any,
  {
    isLoadingCities: boolean;
    cities: any;
    locations: LocationResponse[];
    filterWith: string;
  }
>({
  isLoadingCities: getIsLoadingCitiesSelector,
  cities: getCitiesSelector,
  locations: getLocationsSelector,
  filterWith: getLocationFilterSelector,
});

const mapDispatchToProps = {
  getCities,
  getLocations,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(EnhancedMapFilter));
